module.exports = "<app-widgets-navbar entries=$ctrl.entries validate=false switch-tab-prefix=app.home> </app-widgets-navbar>";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/home/navbar/partial.html
// module id = 414
// module chunks = 0